import { create } from "zustand";
import { createMeetingsSlice, MeetingsSlice } from "./meetings_slice";
import {
  createMeetingTypesSlice,
  MeetingTypesSlice,
} from "./meeting_types_slice";

export const useBoundStore = create<MeetingsSlice & MeetingTypesSlice>()(
  (...a) => ({
    ...createMeetingsSlice(...a),
    ...createMeetingTypesSlice(...a),
  })
);
